import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import CardImage from '../CardImage';

const TradeCardTile = ({ card, onRemove, onTap }) => {
  const { theme } = useTheme();
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);

  const formatPrice = (price) => {
    if (!price && price !== 0) return '?';
    if (price >= 1000) return `$${(price / 1000).toFixed(1)}k`;
    if (price >= 100) return `$${Math.round(price)}`;
    return `$${price.toFixed(2)}`;
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (showConfirmRemove) {
      onRemove(card.id);
    } else {
      setShowConfirmRemove(true);
      setTimeout(() => setShowConfirmRemove(false), 3000);
    }
  };

  return (
    <div
      style={{
        ...styles.tile,
        backgroundColor: theme.bgCard,
        border: `1px solid ${theme.border}`,
        cursor: onTap ? 'pointer' : 'default',
      }}
      onClick={onTap}
    >
      {/* Card photo thumbnail */}
      <div style={styles.photoWrap}>
        <CardImage
          digitalImage={card.digitalImage}
          userPhoto={card.userPhoto}
          name={card.name}
          number={card.number}
          setName={card.setName}
          preferPhoto
          theme={theme}
          imgStyle={styles.photo}
        />
      </div>

      {/* Card info */}
      <div style={styles.info}>
        <span style={{ ...styles.name, color: theme.text }}>
          {card.name}
        </span>
        <span style={{ ...styles.meta, color: theme.textSecondary }}>
          {card.setName} {card.number ? `#${card.number}` : ''}
        </span>
        <span style={{ ...styles.condition, color: theme.textMuted }}>
          {card.condition} {card.variant !== 'Normal' ? `- ${card.variant}` : ''}
        </span>
      </div>

      {/* Right side: price + remove */}
      <div style={styles.rightCol}>
        {/* Price badge or loading spinner */}
        {card.priceLoading ? (
          <div style={{
            width: 16,
            height: 16,
            border: `2px solid ${theme.border}`,
            borderTopColor: theme.accent,
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }} />
        ) : (
          <div style={{
            ...styles.priceBadge,
            backgroundColor: card.price ? theme.successBg : theme.warningBg,
            color: card.price ? theme.success : theme.warning,
          }}>
            {formatPrice(card.price)}
          </div>
        )}

        {/* Remove button */}
        <button
          style={{ ...styles.iconBtn, color: showConfirmRemove ? theme.error : theme.textMuted }}
          onClick={handleRemove}
          aria-label={showConfirmRemove ? 'Confirm remove' : 'Remove card'}
        >
          {showConfirmRemove ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
          )}
        </button>
      </div>
    </div>
  );
};

const styles = {
  tile: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 8,
    borderRadius: 10,
  },
  photoWrap: {
    width: 48,
    height: 67,
    borderRadius: 6,
    overflow: 'hidden',
    flexShrink: 0,
  },
  photo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  meta: {
    fontSize: 11,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  condition: {
    fontSize: 11,
  },
  rightCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 6,
    flexShrink: 0,
  },
  priceBadge: {
    padding: '4px 8px',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 700,
    flexShrink: 0,
  },
  iconBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: 6,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
  },
};

export default TradeCardTile;
